var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    xmlns: "http://www.w3.org/2000/svg",
    height: 102,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    "data-testid": "light",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 47.662,
    y: 86.654,
    width: 6.676,
    height: 1.855,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(255, 255, 255)"
    },
    className: "fills",
    "data-testid": "svg-rect"
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 44.231,
    y: 83.084,
    width: 13.585,
    height: 1.855,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(255, 255, 255)"
    },
    className: "fills",
    "data-testid": "svg-rect"
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 44.231,
    y: 79.56,
    width: 13.585,
    height: 1.855,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(255, 255, 255)"
    },
    className: "fills",
    "data-testid": "svg-rect"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.047 77.937H43.999l-.093-.788c-.973-7.14-3.57-10.246-6.073-13.26-2.875-3.431-5.61-6.723-5.61-15.022 0-10.292 8.438-18.638 18.823-18.638 10.386 0 18.824 8.346 18.824 18.638 0 8.346-2.735 11.591-5.61 15.022-2.504 3.014-5.1 6.12-6.074 13.26l-.139.788Z",
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(255, 255, 255)"
    },
    className: "fills",
    "data-testid": "svg-path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.622 76.083h10.803c1.112-7.094 3.894-10.432 6.351-13.399 2.782-3.339 5.193-6.213 5.193-13.863 0-9.226-7.604-16.784-16.923-16.784-9.319 0-16.922 7.511-16.922 16.784 0 7.65 2.411 10.524 5.192 13.816 2.411 3.014 5.193 6.352 6.306 13.446Z",
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(255, 255, 255)"
    },
    className: "fills",
    "data-testid": "svg-path"
  }), /*#__PURE__*/React.createElement("g", {
    "data-testid": "svg-g",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 70.429,
    y: 62.394,
    transform: "rotate(-45.267 71.356 68.77)",
    width: 1.855,
    height: 12.75,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(255, 255, 255)"
    },
    className: "fills",
    "data-testid": "svg-rect"
  })), /*#__PURE__*/React.createElement("g", {
    "data-testid": "svg-g",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 24.285,
    y: 67.849,
    transform: "rotate(-44.733 30.66 68.776)",
    width: 12.75,
    height: 1.855,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(255, 255, 255)"
    },
    className: "fills",
    "data-testid": "svg-rect"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.498 51.788c-.417 0-.881-.093-1.344-.278-1.252-.464-1.901-2.365-2.829-5.054-1.159-3.384-2.596-7.65-5.239-8.206l.371-1.762-.092-.695c3.152-.464 6.722.742 9.133 3.013 1.994 1.901 2.967 4.359 2.736 6.909-.047.463-.047.927-.093 1.344-.093 1.855-.186 3.57-1.391 4.358a2.33 2.33 0 0 1-1.252.371Z",
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(255, 255, 255)"
    },
    className: "fills",
    "data-testid": "svg-path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.775 37.647c2.133 1.855 3.339 5.332 4.312 8.253.51 1.53 1.252 3.616 1.716 3.895.51.185.788.185.927.092.417-.278.51-1.854.556-2.921.047-.463.047-.973.093-1.437.186-1.947-.603-3.894-2.179-5.378a9.637 9.637 0 0 0-5.425-2.504Z",
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(255, 255, 255)"
    },
    className: "fills",
    "data-testid": "svg-path"
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 73.347,
    y: 47.708,
    width: 12.843,
    height: 1.855,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(255, 255, 255)"
    },
    className: "fills",
    "data-testid": "svg-rect"
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 15.856,
    y: 47.708,
    width: 12.843,
    height: 1.855,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(255, 255, 255)"
    },
    className: "fills",
    "data-testid": "svg-rect"
  }), /*#__PURE__*/React.createElement("g", {
    "data-testid": "svg-g",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 29.767,
    y: 22.106,
    transform: "rotate(-45.267 30.695 28.48)",
    width: 1.855,
    height: 12.75,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(255, 255, 255)"
    },
    className: "fills",
    "data-testid": "svg-rect"
  })), /*#__PURE__*/React.createElement("g", {
    "data-testid": "svg-g",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 64.951,
    y: 27.561,
    transform: "rotate(-44.733 71.326 28.489)",
    width: 12.75,
    height: 1.855,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(255, 255, 255)"
    },
    className: "fills",
    "data-testid": "svg-rect"
  })), /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 50.073,
    y: 13.77,
    width: 1.855,
    height: 12.704,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(255, 255, 255)"
    },
    className: "fills",
    "data-testid": "svg-rect"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.53bfd58d9c049d9ea9a44af10d990a67.svg";
export { ForwardRef as ReactComponent };